import React from "react";
import PropTypes from "prop-types";

class SingleValue extends React.Component {
  render() {
    const { selectProps, innerProps, children } = this.props;
    const { classes } = selectProps;
    return (
      <div className={classes.singleValue} {...innerProps}>
        {children}
      </div>
    );
  }
}

SingleValue.propTypes = {
  selectProps: PropTypes.object.isRequired,
  innerProps: PropTypes.object,
  children: PropTypes.string
};

SingleValue.defaultProps = {
  children: ""
};

export default SingleValue;
